import { el, escape } from './dom';

export type FaqItem = { q: string; a?: string; aHtml?: string; short?: boolean };

export type FAQProps = {
  items?: FaqItem[];
};

const DEFAULTS: FaqItem[] = [
  {
    q: "can I redact a photo of my driver's license?",
    a: "yes. faces blur reliably, GPS metadata in the photo gets stripped, and we attempt OCR on the printed text — but stylized ID layouts (security watermarks, custom fonts) often fool browser-side OCR, so we treat manual redaction as the primary tool. drag a box over any field automatic detection misses; the burned-in redaction is identical either way.",
  },
  {
    q: 'is this actually private?',
    a: "yes. open the network tab, drop a file, and check what's there. you'll see code and models loading — none of those requests carry your file. it's not faith, it's a checkable claim.",
    short: true,
  },
  {
    q: 'can someone un-redact what we redact?',
    aHtml:
      'no. we rasterize the page, draw black over the PII, and re-encode. the original text isn\'t in the output file at all. <code>pdftotext</code> finds nothing. copy-paste finds nothing. same technique journalists use for source documents.',
  },
  {
    q: 'why not just Adobe?',
    a: "Adobe's redaction fails ~65% of the time in independent tests. also $24.99/month forever vs. $19 once.",
    short: true,
  },
];

export const FAQ = (props: FAQProps = {}): HTMLElement => {
  const items = props.items ?? DEFAULTS;
  const itemsHtml = items
    .map((i) => {
      const answer = i.aHtml ?? escape(i.a ?? '');
      return `
        <div class="faq-item${i.short ? ' short' : ''}">
          <h3>${escape(i.q)}</h3>
          <p>${answer}</p>
        </div>`;
    })
    .join('');

  return el(`
    <section class="faq">
      <div class="container">
        <div class="section-header">
          <span class="label">questions you'd reasonably ask</span>
          <h2>we'd ask these too<span class="accent-period">.</span></h2>
        </div>
        <div class="faq-grid">${itemsHtml}</div>
      </div>
    </section>
  `);
};
